var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRename = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71875 13H0V11.2812L9.69187 1.56531L11.4347 3.30844L1.71875 13ZM11.8037 2.9375L10.0625 1.19625L11.0519 0.238128C11.2047 0.0843777 11.4391 2.76349e-06 11.6562 2.76349e-06C11.7632 -0.000276565 11.8691 0.0206222 11.9679 0.0614929C12.0667 0.102364 12.1564 0.162397 12.2319 0.238128L12.7631 0.769378C12.8385 0.844764 12.8983 0.934325 12.9389 1.0329C12.9796 1.13148 13.0003 1.23712 13 1.34375C13 1.5625 12.9153 1.79531 12.7619 1.94875L11.8037 2.9375Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRename);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rename.d76afbff9d87e50d4523be3cd38af3f5.svg";